// import {
//     ONCALL,
//     RTCPROCESS,RTCFAILED,RTCENDED
//      } from "./BackgroundTypes";
import { ONCALL,RTCPROCESS,RTCENDED,RTCFAILED,SET_WEBRTCSTATUS,SET_SHOWCALLLOGPAGE,SET_AGENTSTATUS } from "./permission-type";
const initialState = {
    oncall: false,
    rtcprocess:false,
    rtcfailed:false,
    rtcended:false,
    setwebrtcstatus:true,
    setshowcalllogpage:true,
    setagentstatus:false,
    
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case ONCALL:
    
        return {
          ...state,
          oncall: action.payload,
        };
        
             case RTCPROCESS:
          
            return {
              ...state,
              rtcprocess:action.payload,
            };
            
            case RTCFAILED:
             
              return {
                ...state,
                rtcfailed:action.payload,
              };
              
            
                
                case SET_WEBRTCSTATUS:
                 
                  return {
                    ...state,
                    setwebrtcstatus:action.payload,
                  }; 

                  case SET_SHOWCALLLOGPAGE:
                   return {
                      ...state,
                      setshowcalllogpage:action.payload,
                    }; 
                    
                    case SET_AGENTSTATUS:
                   return {
                      ...state,
                      setagentstatus:action.payload,
                    }; 
  

                


         
         
           
      
        default:
        return state;
    }
  };
  export default reducer;
  